import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Calendar } from "./ui/calendar";
import { Button } from "./ui/button";

const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export default function RescheduleDialog({ open, onOpenChange, booking, phone, onDone }) {
  const { t } = useApp();
  const [date, setDate] = useState(null);
  const [slots, setSlots] = useState(null);
  const [time, setTime] = useState("");
  const [busy, setBusy] = useState(false);

  const pick = (d) => {
    if (!d) return;
    setDate(d); setTime(""); setSlots(null);
    api.get(`/availability?date=${fmt(d)}`).then((r) => setSlots(r.data.slots)).catch(() => setSlots([]));
  };

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/bookings/reschedule", { reference: booking.reference, phone, date: fmt(date), time });
      toast.success(t.my.rescheduled);
      onDone(data);
      onOpenChange(false);
      setDate(null); setSlots(null); setTime("");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  const available = (slots || []).filter((s) => s.available && !(fmt(date) === booking.date && s.time === booking.time));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl" data-testid="reschedule-dialog">
        <DialogHeader>
          <DialogTitle>{t.my.rescheduleTitle}</DialogTitle>
          <DialogDescription>{t.my.rescheduleRule}</DialogDescription>
        </DialogHeader>
        <div className="grid place-items-center">
          <Calendar mode="single" selected={date} onSelect={pick}
            disabled={(d) => d < new Date(new Date().setHours(0, 0, 0, 0))}
            className="rounded-2xl" data-testid="reschedule-calendar" />
        </div>
        {date && (slots === null ? (
          <div className="grid place-items-center py-6"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        ) : available.length === 0 ? (
          <p className="text-center text-muted-foreground py-4">{t.booking.noSlots}</p>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid="reschedule-slots">
            {available.map((s) => (
              <button key={s.time} onClick={() => setTime(s.time)} dir="ltr" data-testid={`reschedule-slot-${s.time}`}
                className={`py-3 rounded-xl text-sm font-semibold transition-colors ${time === s.time ? "bg-primary text-primary-foreground" : "bg-muted hover:bg-secondary"}`}>
                {s.time}
              </button>
            ))}
          </div>
        ))}
        <Button onClick={submit} disabled={!date || !time || busy} className="w-full h-12 rounded-full font-semibold mt-2" data-testid="reschedule-confirm-btn">
          {busy && <Loader2 className="h-4 w-4 animate-spin me-2" />} {t.my.rescheduleConfirm}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
